import { ColumnInterface } from '@shared/interfaces/column.interface'
import { WatchListColumnsEnum } from '@shared/components/trading/widgets/watch-list-widget/core/enums/watch-list-columns.enum'

export const WatchListColumnsConstant: ColumnInterface<WatchListColumnsEnum>[] = [
	{
		column: WatchListColumnsEnum.ticker,
		visible: true,
	},
	{
		column: WatchListColumnsEnum.company,
		visible: true,
	},
	{
		column: WatchListColumnsEnum.price,
		visible: true,
	},
	{
		column: WatchListColumnsEnum.watchListChangeColumnDollar,
		visible: true,
	},
	{
		column: WatchListColumnsEnum.watchListChangeColumnPercent,
		visible: true,
	},
]
